import { DateTime } from "luxon";
import formatDateTime from "../../../utils/formatDateTime";

function formatStateDateTime(targetingJob) {
  switch (targetingJob.state) {
    case "failed":
      return formatDateTime(DateTime.fromISO(targetingJob.finished_at));
    case "completed":
      return formatDateTime(DateTime.fromISO(targetingJob.finished_at));
    case "completed_with_errors":
      return formatDateTime(DateTime.fromISO(targetingJob.finished_at));
    case "executing":
      return formatDateTime(DateTime.fromISO(targetingJob.attempted_at));
    default:
      return "N/A";
  }
}

export default formatStateDateTime;
